<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Advertiser Management</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><u>Filter by Advertiser</u></label>
        <input type="text" class="form-control" placeholder="Regex offer ID" [(ngModel)]="filterable.advertiser" />
      </div>
      <div class="col">
        <label for=""><u>Filter by OfferId</u></label>
        <input type="text" class="form-control" placeholder="Regex offer ID" [(ngModel)]="filterable.offerId" />
      </div>
      <div class="col ml-auto text-right  align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
        <button class="btn btn-outline-success btn-sm text-dark font-weight-bold" [routerLink]="['/dashboard/offer-stream/advertiser/-1']" >+ Advertiser </button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
</div>
<table id="advertiserList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>No</th>
      <th>Advertiser</th>
      <th>OfferID</th>
      <th>Slice</th>
      <th>TimeZone</th>
      <th>Limitation</th>
      <th>URL</th>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="16">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="16">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let advertiser of advertisers; index as i;">
      <td>{{i + 1}}</td>
      <td>{{advertiser.advertiser}}</td>
      <td>{{advertiser.offerId}}</td>
      <td>{{advertiser.slice}}</td>
      <td>{{advertiser.timezone}}</td>
      <td class="text-left">
        MIN: {{advertiser.min}} <br>
        MAX: {{advertiser.max}} <br>
        RATE: {{advertiser.rate}}
      </td>
      <td class="text-left">
        URL: {{advertiser.url}} <br>
        Customize URL: {{advertiser.customizedUrl}}<br>
        <span class="font-weight-bold text-danger font-italic">Postback URL:</span> http://pays2s.intelligent-earnings.com/offer-stream/{{advertiser.advertiser}}/{{advertiser.offerId}}?aff_id=
      </td>
      <td>
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/offer-stream/advertiser', advertiser.id]" >
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteAdvertiser(advertiser)" >
          <i class="fas fa-trash"></i>
        </button>
        <a class="btn btn-sm btn-primary mt-2" [routerLink]="['/dashboard/offer-stream/advertiser', advertiser.id, 'affiliate']">
          <span class="badge">Affiliate</span>
        </a>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="16" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
      </td>
    </tr>
  </tfoot>
</table>
